// Paths (relative to /customers/:customerId) that exist in BOTH V1 and V2.
// Derived from src/v2/routes/v2Routes.tsx and src/routes/router.jsx.
const PARITY_TOP_SEGMENTS = new Set<string>([
  "search",
  "dashboard",
  "views",
  "users",
  "sites",
  "roles",
  "summary-templates",
  "connectors",
  "audit-logs",
  "header-names",
  "jobs",
]);

export type UiVersion = "v1" | "v2";

export function mapRoute(
  toUi: UiVersion,
  currentPath: string,
  customerId: string,
  fromUi?: UiVersion
): string {
  const base = `/customers/${customerId}`;
  if (fromUi && fromUi === toUi) return currentPath;

  const afterBase = currentPath.startsWith(base) ? currentPath.slice(base.length) : "";
  const afterV2Prefix = afterBase.replace(/^\/v2(?=\/|$)/, "");
  const rel = afterV2Prefix.replace(/^\//, "");
  const topSegment = rel.split("/")[0] ?? "";

  const hasParity = topSegment !== "" && PARITY_TOP_SEGMENTS.has(topSegment);

  if (toUi === "v2") {
    if (!hasParity) return `${base}/v2`;
    return `${base}/v2/${rel}`;
  }
  if (!hasParity) return base;
  return `${base}/${rel}`;
}
